import { styled, alpha } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
    '& .CUContentContainer': {
        paddingBottom: theme.spacing(6),
        [theme.breakpoints.down('md')]: {
            paddingBottom: theme.spacing(4),
        },
        '& .CUContainer': {
            [theme.breakpoints.down('md')]: {
                paddingLeft: theme.spacing(0),
            },
        },
    },
    '& .CUWrapper': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(2),
            gap: theme.spacing(0.25),
        },
    },
    '& .CUTitleWrapper': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
    },
    '& .CUTitle': {
        marginBottom: 0,
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(0.25),
        },
    },
    '& .CUSubtitle': {
        color: theme.palette.text.secondary,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 500,
    },
    '& .CUContactInfoWrapper': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        marginTop: theme.spacing(1),
        [theme.breakpoints.down('md')]: {
            gap: theme.spacing(4),
            marginTop: theme.spacing(4),
        },
    },
    '& .CUCallUsSection, & .CUMailUsSection': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    '& .CUSectionHeader': {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    '& .CUIcon': {
        fontSize: theme.typography.pxToRem(24),
    },
    '& .CUSectionTitle': {
        textTransform: 'uppercase',
        color: theme.palette.common.white,
        fontSize: theme.typography.pxToRem(16),
        [theme.breakpoints.down('md')]: {
            fontSize: theme.typography.pxToRem(14),
        },
    },
    '& .CUPhoneNumbers': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    '& .CUPhoneItem': {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1, 2),
        borderRadius: theme.spacing(124.875),
        backgroundColor: theme.palette.background.secondary,
        width: 'fit-content',

    },
    '& .CUFlagIcon': {
        width: theme.typography.pxToRem(22.621),
        height: theme.typography.pxToRem(16),
        objectFit: 'cover',
    },
    '& .CUPhoneIcon': {
        fontSize: theme.typography.pxToRem(20),
    },
    '& .CUPhoneLabel': {
        fontSize: theme.spacing(1.75),
        fontWeight: 700,
        color: theme.palette.common.white,
    },
    '& .CUPhoneValue': {
        color: theme.palette.common.white,
        fontSize: theme.spacing(2),
    },
    '& .CUAddress': {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
    },
    '& .CUAddressLine': {
        color: theme.palette.text.secondary,
    },
}));

export default StyledBox;

